// extracted by mini-css-extract-plugin
module.exports = {"chat-image":"ChatImage_chat-image__pG1HX"};